// src/components/sections/SidebarRight.js
import React from 'react';
import Background from './Background';
import Content from './Content';

const SidebarRight = ({ Background: backgroundData, Content: contentItems }) => {
  return (
    <aside className="position-relative bg-white p-3 shadow-sm d-flex flex-column align-items-start justify-content-start overflow-hidden h-100">
      {/* Hintergrund der Sidebar */}
      <Background {...backgroundData}/>

      {/* Inhalt der Sidebar */}
      <div className="position-relative w-100">
        {contentItems && contentItems.length > 0 ? (
          contentItems.map((item) => (
            <Content key={item.id} {...item} />
          ))
        ) : (
          <p className="text-muted">Kein Inhalt für diese Sidebar vorhanden.</p>
        )}
      </div>
    </aside>
  );
};

export default SidebarRight;
